export default __webpack_public_path__ + "static/media/ovalgrey.38c39ac9.svg";